import axios from 'axios'

export const fetchChatPatterns = () => axios.get('/chatpattern')
